/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_Pick_TitleInputs */

const vi_grower_area_qr_pick_title = /** @type {(inputs: Grower_Area_Qr_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vùng trồng`)
};

/**

* @param {Grower_Area_Qr_Pick_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_pick_title = /** @type {((inputs?: Grower_Area_Qr_Pick_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_Pick_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_pick_title(inputs)
});